import React from "react";

type Position = { top: number, left: number };
export const MovingCover = () => {

    const [moving, setMoving] = React.useState<boolean>(false);
    const [initial_scroll_pos, setInitialScrollPos] = React.useState<Position>({top: 0, left: 0});
    const [initial_mouse_pos, setInitialMousePos] = React.useState<Position>({top: 0, left: 0});
    const [originalScrollBehavior, setOriginalScrollBehavior] = React.useState<string>('');

    const scroll_element = (document.scrollingElement ?? document.documentElement) as HTMLElement;

    const handleMouseDown = (e: React.MouseEvent) => {
        setMoving(true);
        setInitialScrollPos({top: scroll_element.scrollTop, left: scroll_element.scrollLeft});
        setInitialMousePos({top: e.screenY, left: e.screenX});
        setOriginalScrollBehavior(scroll_element.style.scrollBehavior);
    }
    const handleMouseMove = (e: React.MouseEvent) => {
        if (moving) {
            scroll_element.style.scrollBehavior = 'auto'; // デフォルトだと スムーススクロールが効いてしまって、上手く移動できなかったのでした
            scroll_element.scrollTop = initial_scroll_pos.top - (e.screenY - initial_mouse_pos.top);
            scroll_element.scrollLeft = initial_scroll_pos.left - (e.screenX - initial_mouse_pos.left);
        }
    }
    const handleMouseUp = (e: React.MouseEvent) => {
        setMoving(false);
        scroll_element.style.scrollBehavior = originalScrollBehavior;
    }

    const style = {
        cursor: moving ? "grabbing" : "grab",
    };

    return (
        <div className={"moving-cover"}
             style={style}
             onMouseDown={handleMouseDown}
             onMouseMove={handleMouseMove}
             onMouseUp={handleMouseUp}
        />
    );
}
